"use client";

import FeesCard from "@molecules/FeesCard/FeesCard";
import styles from "./FeesSection.module.scss"

export default function FeesSection({ Fees, country,isLandingPage, isSpecificPage}: { Fees: any; country: string ,isLandingPage?:boolean; isSpecificPage?:boolean}) {
  if (!Fees?.enabled) return null;
  const emi =
    Fees?.FeesOptions?.find((x) => {
      return (
        (!x?.Country || x?.Country == "All" || x?.Country == country) &&
        x?.enabled &&
        x?.Type == "Emi"
      );
    }) || null;
  const nonEmi =
    Fees?.FeesOptions?.filter((x) => {
      return (
        (!x.Country || x?.Country == "All" || x?.Country == country) &&
        x?.enabled &&
        x?.Type != "Emi"
      );
    }) || [];
  return (
    <div id={`${Object.keys({Fees})}`}>
      <div className={styles.container}>
        <h2 className={styles.feeStructure}>Fee Structure</h2>
        <hr className="h-[1px] flex-1 lg:ml-4 lg:mt-5" />
        <div className="lg:grid gap-y-4 lg:grid-cols-4 lg:gap-x-6 md:grid gap-y-4 md:grid-cols-2 md:gap-6 pt-7" >
          {emi ? (
            <div className="mb-4 md:mb-0 lg:mb-0">
              <FeesCard {...emi}  classname={isSpecificPage?styles.cardSpecific:styles.fees_card}  country={country}  />
            </div>
          ) : null}
          {nonEmi.map((item: any, i: number) =>  (
            <div className={`lg:col-span-1 ${i != 0 ? "mt-4 lg:mt-0 md:mt-0" : ""}`}>
              <FeesCard {...item} country={country}  classname={isSpecificPage?styles.hoverEffectCardSpecific : styles.hoverEffectCard} />
            </div>
          ))}
          <div className="mb-4 mt-4 lg:m-0 md:m-0">
            <FeesCard
                SecondaryHeading={`Attractive Scholarships Available`}
                classname={isSpecificPage?styles.hoverEffectCardSpecific : styles.hoverEffectCard}
                isScholarshipAvailable={true}
                isLandingPage={isLandingPage}
                />
          </div>
        </div>
      </div>
    </div>
  );
}
